import { render, staticRenderFns } from "./HubCalendarDetail.vue?vue&type=template&id=1cb340ca&"
import script from "./HubCalendarDetail.vue?vue&type=script&lang=js&"
export * from "./HubCalendarDetail.vue?vue&type=script&lang=js&"
import style0 from "./HubCalendarDetail.vue?vue&type=style&index=0&id=1cb340ca&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports